/*
|--------------------------------------------------------------------------
| Ads: Flipp
|--------------------------------------------------------------------------
*/
/**
 * Loads Flipp widget targeted to appendID  
 */
__gh__webApp.ads.flipp = {
	
	/**
	 * Initialize
	 */
	"init": function(){
		this.loadWidgetElement();
	},
	"loadWidgetElement": function(){
		
		var thisObject=this,
			appendID = 'flipp-promo',
			elementID= 'circularhub_module_2507',
			myElem = document.getElementById(appendID);
		
		//Create div
		var flippDiv = document.createElement('div'),
		el=document.getElementById(appendID);
		flippDiv.id = elementID; // Id must be the same as slotName

		el.insertBefore(flippDiv,el.firstChild); //add to dom	
		
		this.loadWidgetLib(elementID);
	},
	"loadWidgetLib": function(elementID){
		
		var src	= "//api.circularhub.com/2507/6a30c3054563b03c/circularhub_module.js",
		dom 	= document.getElementById(elementID),
		script 	= document.createElement('script');
		script.src = src;
		
		//Append to dom
		dom.appendChild(script);

	}

};